import {
    deleteTesseractDeviceDetails,
    fetchTesseractDeviceDetails,
    setTesseractDeviceDetails, updateTesseractConfiguration,
    updateTesseractDeviceDetails,
    updateTesseractDeviceMac,
    updateTesseractMonitoringDetails
} from "../network/TesseractDeviceNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const TesseractDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            fetchTesseractDeviceDetails(action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setTesseractDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_DATA":
            updateTesseractDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_MAC":
            updateTesseractDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac,
                action.data.showCustomAlert)
            return state
        case "UPDATE_MONITORING_DATA":
            updateTesseractMonitoringDetails(action.data.dispatcher, action.data.stateValues,
                action.data.mac)
            return state
        case "DELETE_DEVICE_DATA":
            deleteTesseractDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "UPDATE_TESSERACT_CONFIGURATION":
            updateTesseractConfiguration(action.data.dispatcher, action.data.configurations,
                action.data.mac,  action.data.showCustomAlert)
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/reducer/TesseractDeviceOverviewReducer.js